import React, { useState } from 'react'
import axios from 'axios'
import Swal from 'sweetalert2'

const urlAgregar = 'https://datosprofes.cpem46.edu.ar/Backendphp/agregar_materia.php'

const AgregarMateria = ({ setSeccion, docenteId, onGuardarExitoso }) => {
  const [formData, setFormData] = useState({
    cod_cargo: '',
    sec: '',
    tgsT: '',
    tgsG: '',
    tgsS: '',
    cod_materia: '',
    asignatura: '',
    hs: '',
    sr: '',
    al: '',
    suple_a: ''
  })

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }))
  }

  const handlePaste = (e) => {
    const clipboardData = e.clipboardData.getData('Text')
    const valores = clipboardData.trim().split('\t')

    if (valores.length < 11) {
      Swal.fire({
        title: 'Error',
        text: 'Faltan columnas en los datos pegados desde Excel.',
        icon: 'error',
      })
      e.preventDefault()
      return
    }

    const nuevoFormData = {
      cod_cargo: valores[0] || '',  // categoria
      sec: valores[1] || '',        // secuencia
      tgsT: valores[2] || '',       // turno
      tgsG: valores[3] || '',       // grado
      tgsS: valores[4] || '',       // seccion
      cod_materia: valores[5] || '', // materia
      asignatura: valores[6] || '',  // descripcion
      hs: valores[7] || '',          // horas
      sr: valores[10] || '',         // sit revista
      al: valores[12] || '',         // fecha alta
      suple_a: '',                    // campo opcional
    }

    setFormData(nuevoFormData)
    e.preventDefault()
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    const hasData = Object.values(formData).some(field => field !== '')
    if (!hasData) {
      Swal.fire({
        title: 'Error',
        text: 'Debes completar al menos un campo.',
        icon: 'error',
      })
      return
    }

    Swal.fire({
      title: '¿Estás seguro?',
      text: '¿Querés agregar esta materia?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, agregar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        agregarMateria()
      }
    })
  }

  const agregarMateria = () => {
    const dataAEnviar = {
      docente_id: docenteId,
      cod_cargo: formData.cod_cargo,
      sec: formData.sec,
      tgs: formData.tgsT +" "+ formData.tgsG +" "+ formData.tgsS,
      cod_materia: formData.cod_materia,
      asignatura: formData.asignatura,
      hs: formData.hs,
      sr: formData.sr,
      al: formData.al,
      suple_a: formData.suple_a
    }

    axios.post(urlAgregar, dataAEnviar, {
      withCredentials: true // <- ESTO ES CLAVE
    })
    .then((res) => {
        if (res.data.success) {
          Swal.fire({
            title: 'Éxito',
            text: 'Materia agregada correctamente',
            icon: 'success',
          })
          onGuardarExitoso()
          setSeccion('')
        } else {
          Swal.fire({
            title: 'Error',
            text: 'Hubo un error al agregar la materia',
            icon: 'error',
          })
        }
      })
      .catch((err) => {
        console.error('Error al enviar la solicitud:', err)
        Swal.fire({
          title: 'Error',
          text: 'Hubo un error al agregar la materia',
          icon: 'error',
        })
      })
  }

  const handleCancelar = () => {
    setSeccion('')
  }

  return (
    <div className="form-register2">
      <h1>Agregar Materia</h1>
      <form onSubmit={handleSubmit}>
        <div className='tabla-responsive'>
          <table className="tabla-asignacion">
            <thead>
              <tr>
                <th>Cod. Cargo</th>
                <th>sec</th>
                <th>T</th>
                <th>G</th>
                <th>S</th>
                <th>Cod. Materia</th>
                <th>Asignatura</th>
                <th>hs</th>
                <th>-</th>
                <th>-</th>
                <th>sr</th>
                <th>-</th>
                <th>al</th>
                <th>Suple a</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <input
                    type="text"
                    name="cod_cargo"
                    className="controls2"
                    value={formData.cod_cargo}
                    onChange={handleInputChange}
                    onPaste={handlePaste}
                  />
                </td>
                <td><input type="text" name="sec" className="controls2" value={formData.sec} onChange={handleInputChange} /></td>
                <td><input type="text" name="tgsT" className="controls2" value={formData.tgsT} onChange={handleInputChange} /></td>
                <td><input type="text" name="tgsG" className="controls2" value={formData.tgsG} onChange={handleInputChange} /></td>
                <td><input type="text" name="tgsS" className="controls2" value={formData.tgsS} onChange={handleInputChange} /></td>
                <td><input type="text" name="cod_materia" className="controls2" value={formData.cod_materia} onChange={handleInputChange} /></td>
                <td><input type="text" name="asignatura" className="controls2" value={formData.asignatura} onChange={handleInputChange} /></td>
                <td><input type="text" name="hs" className="controls2" value={formData.hs} onChange={handleInputChange} /></td>
                <td></td>
                <td></td>
                <td><input type="text" name="sr" className="controls2" value={formData.sr} onChange={handleInputChange} /></td>
                <td></td>
                <td><input type="text" name="al" className="controls2" value={formData.al} onChange={handleInputChange} /></td>
                <td><input type="text" name="suple_a" className="controls2" value={formData.suple_a} onChange={handleInputChange} /></td>
              </tr>
            </tbody>
          </table>
        </div>

        <div style={{ marginTop: '1rem' }}>
          <input className="botons" type="submit" value="Agregar Materia" />
          <input className="botons" type="button" value="Cancelar" onClick={handleCancelar} />
        </div>
      </form>
    </div>
  )
}

export default AgregarMateria
